import React, { useState, useEffect, useContext } from 'react';
import {Route, Routes} from "react-router-dom";

import Prj_Home from './prj/home.js';
import Prj_Prjs from './prj/prjs.js';
import Prj_Utv from './prj/utv.js';
import Prj_Kund from './prj/kund.js';
import {withRouter} from "../lib/react/withRouter";
import sso from "../sso";

function pg_home() {

    var html =
    <div className="web-content">
      Hem
    </div>
    ;
    return html;
}

class Bcs_Prj extends React.Component {
    //var sdo = useContext(SDO);
  constructor(props, context) {
    super(props);

    this.webStore = props.store;
    this.state = { pgid: 11, deps: [] };
    //context.posrend = this;
  }
  fknGo(row) {
    //alert(row.href);
      sso.seo.sfkn = row;
    this.props.navigate(row.url);
  }
    br_css(row) {
        var css = {};
        if(sso.seo.sfkn && (row.url == sso.seo.sfkn.url)) css.color = "#080";
        //var brc = false;
        //if(row.url == sbo.state.url) brc = true;
        return css;
    }

  render() {
      var path = window.location.pathname;
      if(path.substr(-1) == "/") path = path.substring(0, path.length - 1);
      var op = path.split("/").pop();
      var po = {};
      po.prjs = { "fid": "f04", "url": "/bcs/prj/prjs", "name": "Projekt", "active": false };
      po.utv = { "fid": "f04", "url": "/bcs/prj/utv", "name": "Utveckling", "active": false };
      po.kund = { "fid": "f04", "url": "/bcs/prj/kund", "name": "Kund", "active": false };
      if(po[op]) {
          po[op].active = true;
          this.props.store.fkn = po[op];
      }
      var pa = Object.values(po);

    return (

    <div className="web-app">
         { this.props.store.cfg.bread ?
             <div className="web-bread">
                 <div className="breadcrumb">
            { pa.map((row, key) =>
                <div key={key} className="breadcrumb-item" style={this.br_css(row)} onClick={() => this.fknGo(row)}>{row.name}</div>
            )}
            <div className="flex"></div>
            <div className="cdigreen">{ this.props.store.fkn ? this.props.store.fkn.name : null }</div>
            </div>
        </div>
        : null }
        <Routes>
          <Route path="/xx" component={pg_home} />
            <Route path="prjs" element={ <Prj_Prjs store={this.webStore} />} />
            <Route path="utv" element={ <Prj_Utv store={this.webStore} />} />
            <Route path="kund" element={ <Prj_Kund store={this.webStore} />} />
            <Route path="*" element={ <Prj_Home store={this.webStore} />} />
        </Routes>
    </div>

  );
}
}
//Sys.contextType = ADOContext;

export default withRouter(Bcs_Prj);
